export const typeStatus = [
  { value: 'Active' },
  { value: 'Inactive' },
];
